<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات حقوق</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">نام و نام خانوادگی</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"> سال </label>
          <select [(ngModel)]="Filter_year" (change)="ReadData_Salary()" class="custom-select">
            <option value="1403">سال 1403</option>
            <option value="1404">سال 1404</option>
            <option value="1405">سال 1405</option>
            <option value="1406">سال 1406</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Salary()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" (click)="Set_Form_Salary_View_Add()" type="button" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات کلی حقوق </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>حق عضویت</th>
              <th>حق شاغل</th>
              <th>حق شغل</th>
              <th colspan="2">عملکرد</th>
              <th colspan="2">جمع کل</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>

            <ng-container *ngFor="let item of DataList_Salary
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Salary|filter:Filter_title:'fullname').length
                      }
            ">

              <tr>
                <td rowspan="2">{{DataList_Salary.indexOf(item)+1}}</td>
                
                <td>{{item.fullname}}</td>
                <td>{{item.partnership|number}}</td>
                <td>{{item.person|number}} </td>
                <td>{{item.position|number}} </td>
                <td colspan="2">{{item.performance|number}} </td>
                <td colspan="2">{{item.salary|number}} </td>

                <td rowspan="2">
                  <button (click)="Set_Form_Salary_View_Add2(item.personId,item.fullname)" type="button"
                    class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ویرایش
                  </button>
                </td>

              </tr>

              <tr>
                <th>ضریب شاغل</th>
                <td>{{item.person_rate|number}} </td>

                <th>ضریب شغل</th>
                <td>{{item.position_rate|number}} </td>

                <th>ساعت اضافه کاری</th>
                <td>{{item.ezakekarHour|number}} </td>

                <th>ماموریت</th>
                <td>{{item.missionHour|number}} </td>

              </tr>

            </ng-container>


          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>

<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='BaseForm'">
  <app-SalaryBaseForm [inner_Year]="Selected_Salary_Year" (outter_Salary)="Set_List_Salary_View($event)">
  </app-SalaryBaseForm>
</div>



<div class="col-md-12 mb-30" *ngIf="Selected_Salary_Record_Switcher=='PersonForm'">
  <app-SalaryPersonForm [inner_Year]="Selected_Salary_Year" [inner_PersonId]="Selected_Salary_PersonId"
    [inner_Person_Fullname]="Selected_Salary_Person_Fullname" (outter_Salary)="Set_List_Salary_View($event)">
  </app-SalaryPersonForm>
</div>